import { AnalyticsQueryArgs } from "../Analytics"

export function getSubTime(time: AnalyticsQueryArgs["time"]) {
  const { from, to, subFrom, subTo } = time
  return subFrom && subTo ? { from: subFrom, to: subTo } : { to: from, from: from - (to - from) }
}
